import * as actionTypes from './actionTypes'
import { calculateCheckDigit } from '../api/util'
import get from 'lodash/get'
export function updateEntryTypeField(field, payload) {
  return {
    type: actionTypes.UPDATE_ENTRY_TYPE_FIELD,
    payload,
    field
  }
}
export function updateSummaryDateField(field, payload) {
  return {
    type: actionTypes.UPDATE_SUMMARY_DATE_FIELD,
    payload,
    field
  }
}
export function updateEntryDateField(field, payload) {
  return {
    type: actionTypes.UPDATE_ENTRY_DATE_FIELD,
    payload,
    field
  }
}
export function updateFTZDateField(field, payload) {
  return {
    type: actionTypes.UPDATE_FTZ_DATE_FIELD,
    payload,
    field
  }
}

export function saveEntryTypeField(field, payload) {
  return {
    type: actionTypes.SAVE_ENTRY_TYPE_FIELD,
    payload,
    field
  }
}

export function saveEntryNumberAndCheckDigit(entryNumber, checkDigit) {
  return (dispatch, getState) => {
    // Update and Save new values for empty entry number
    if (entryNumber === '_BLANK_') {
      dispatch(saveEntryTypeField('entryNumber', '_BLANK_'))
      return
    }
    // Save new values
    dispatch(saveEntryTypeField('entryNumber', `${entryNumber}${checkDigit}`))
  }
}

export function getCheckDigitAndSaveEntryNumber(
  entryNumber,
  updateValidEntryNumber
) {
  return (dispatch, getState) => {
    if (entryNumber && entryNumber.length<7) {
      return
    }
    // Update and Save new values for empty entry number
    if (entryNumber === '_BLANK_') {
      dispatch(updateEntryTypeField('checkDigit', ''))
      dispatch(saveEntryTypeField('entryNumber', '_BLANK_'))
      return
    }
    // Use API to calculate the checkdigit for the saved entry number
    calculateCheckDigit(
      getState().EntryTypeInfo.filerCode,
      getState().EntryTypeInfo.entryNumber
    ).then(response => {
      // read check digit if it was returned
      let checkDigit = get(
        response,
        'data.eventMessage.msg',
        ''
      ).toUpperCase()
      // Update and Save new values if checkdigit is not -1 and status is 200
      if (checkDigit !== -1 && response.data.eventMessage.code !== 400) {
        dispatch(updateEntryTypeField('checkDigit', checkDigit))
        dispatch(
          saveEntryTypeField('entryNumber', `${entryNumber}${checkDigit}`)
        )
        updateValidEntryNumber(`${entryNumber}`)
      } else updateValidEntryNumber()
    })
  }
}

export function saveEntryTypeDateField(field, payload) {
  return {
    type: actionTypes.SAVE_ENTRY_TYPE_DATE_FIELD,
    payload,
    field
  }
}

export function updateEntryTypeObject(object, field, value) {
  return {
    type: actionTypes.UPDATE_ENTRY_TYPE_OBJECT,
    value,
    field,
    object
  }
}

export function updateEntryTypeErrorWarning(warnings) {
  return {
    type: actionTypes.UPDATE_ENTRY_TYPE_WARNING,
    warnings
  }
}

// export function sa
